export enum ModalAction {
  Ok,
  Cancel,
  YesLeave,
  NoBackToEdit,
  NoBackToAdd,
  YesConfirm,
  NoLeave,
}
